/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import type { SplitButtonState } from "@fluentui/react-components";
import {
  assertSlots,
  renderSplitButton_unstable,
} from "@fluentui/react-components";

import type { AppContextualMenuProps } from "@1js/acui-menu";

import type {
  AppSplitButtonProps,
  AppSplitButtonState,
  AppSplitButtonSlots,
} from "./AppSplitButton.types";

import { MenuContextProviders } from "../../AppFlyoutAnchor/next";
import { AppTooltipContainer } from "@1js/acui-tooltip";
import { ReactUiPaintTiming } from "@1js/acui-paint-timing";
import { useAsyncUiTracking } from "../../../hooks/useAsyncUITracking";

export const renderAppSplitButton = (
  state: AppSplitButtonState,
  props: AppSplitButtonProps
) => {
  const { id, location } = props;
  const splitButtonState = state as SplitButtonState;
  assertSlots<AppSplitButtonSlots>(state);
  const {
    shadowRenderMenu,
    isShadowRendering,
    persistMenu,
    menuAnchorContextValue,
  } = state;

  // VSO:5851658 see if we can remove the cast for menu, typescript
  // says the union type is too complex
  const shouldRenderMenu =
    !(state.menu as AppContextualMenuProps).hidden ||
    (shadowRenderMenu && isShadowRendering) ||
    persistMenu;

  const shouldTrackAsyncUI =
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useAsyncUiTracking();

  return (
    <AppTooltipContainer
      {...props}
      showTooltip={props.showTooltip && !shouldRenderMenu}
    >
      {shouldTrackAsyncUI && (
        <ReactUiPaintTiming
          elementTimingId={id}
          hidden={(state.menu as AppContextualMenuProps).hidden}
          interactivityTrackerContext={`${id}_${location}`}
        />
      )}

      <MenuContextProviders
        isShadowRendering={isShadowRendering}
        menuAnchorContextValue={menuAnchorContextValue}
      >
        <>
          {renderSplitButton_unstable(splitButtonState)}
          {shouldRenderMenu && <state.menu />}
        </>
      </MenuContextProviders>
    </AppTooltipContainer>
  );
};
